module.exports = __webpack_public_path__ + "static/media/157.bbef06a1.mp3";